const META_PIXEL_ID = "1514363203367475";

type MetaPixel = (...args: unknown[]) => void;

declare global {
  interface Window {
    fbq?: MetaPixel & {
      callMethod?: MetaPixel;
      queue?: Array<unknown[]>;
      push?: (...args: unknown[]) => void;
      loaded?: boolean;
      version?: string;
    };
  }
}

export function initializeMetaPixel() {
  if (typeof window === "undefined" || window.fbq) return;

  const fbq = function (...args: unknown[]) {
    if (fbq.callMethod) {
      fbq.callMethod(...args);
      return;
    }

    fbq.queue?.push(args);
  } as MetaPixel & {
    callMethod?: (...args: unknown[]) => void;
    queue?: Array<unknown[]>;
    push?: (...args: unknown[]) => void;
    loaded?: boolean;
    version?: string;
  };

  fbq.queue = [];
  fbq.push = (...args: unknown[]) => {
    fbq.queue?.push(args);
  };
  fbq.loaded = true;
  fbq.version = "2.0";
  window.fbq = fbq;

  const script = document.createElement("script");
  script.async = true;
  script.src = "https://connect.facebook.net/en_US/fbevents.js";
  document.head.appendChild(script);

  window.fbq("init", META_PIXEL_ID);
  window.fbq("track", "PageView");
}

export function trackMetaEvent(event: "AddToCart") {
  window.fbq?.("track", event);
}
